module.exports = __webpack_public_path__ + "static/media/macbook_pro.4ffa184a.jpg";